<nb-card-header *ngIf="!isWatchingFromApp && !this.isSdui" [ngClass]="iconCustomLayoutClass()" >
  <a (click)="backUrlClick()" style="cursor: pointer;"
     class="header-btn">
     <img src="/assets/images/bt-back-new.svg" class="icons-svg-list">
  </a>
</nb-card-header>

<nb-card-header *ngIf="!isWatchingFromApp && this.isSdui" [ngClass]="iconCustomLayoutClass()" >
  <a (click)="back()" style="cursor: pointer;"
     class="header-btn">
     <img src="/assets/images/bt-back-new.svg" class="icons-svg-list">
  </a>
</nb-card-header>
